import moduleLoader from "./components/moduleLoader";
import naja from "naja";
import netteForms from "./components/netteForms";
import toast from "./components/toast";
import popover from "./components/popover";
import typeahead from "./components/typeahead";
import flatpickr from "./components/flatpickr";
import lightbox from "./components/lightbox";
import datagrids from "@flexsyscz/datagrids";
import {Ajax} from "./components/ajax";
import tooltip from "./components/tooltip";
import modal from "./components/modal";

import articleManager from "./components/articleManager";
import pageManager from "./components/pageManager";
import profileManager from "./components/profileManager";


naja.initialize()

netteForms()
datagrids()

const html = document.querySelector('html')
if (html.dataset.scope) {
	const scope = html.dataset.scope
	const target = scope.split('.').join('_')

	moduleLoader(html, target)
}

const ajax = new Ajax(document, false)
ajax.onAfterUpdate((root) => {
	toast(root)
	tooltip(root)
	popover(root)
	typeahead(root)
	flatpickr(root)
	lightbox(root)
	modal(root)
}).run()

const cms = new Ajax(document)
cms.onAfterUpdate((root) => {
	articleManager(root)
	pageManager(root)
	profileManager(root)
}).run()

const isLoggedInUrl = html.dataset.isLoggedIn
const timeout = html.dataset.signedInTimeout
if (isLoggedInUrl && timeout) {
	checkUserIsLoggedIn()
}

function checkUserIsLoggedIn() {
	setTimeout(() => {
		naja.makeRequest('GET', isLoggedInUrl, null, {history: false})
			.then((payload) => {
				if(!payload.response) {
					window.location = '/'
				} else {
					checkUserIsLoggedIn()
				}
			})
			.catch((error) => {
			})
	}, 1000 * parseInt(timeout) + 30000)
}
